import type { Dispatch, ReactNode, SetStateAction} from 'react';
import { createContext, useState } from 'react';
import type { ExpressWidgetError } from '../../typings/error.types';

export interface ErrorContextType {
    expressWidgetError: ExpressWidgetError | null;
    setExpressWidgetError: Dispatch<SetStateAction<ExpressWidgetError | null>>;
}

export const ErrorContext = createContext<ErrorContextType>({
    expressWidgetError: null,
    setExpressWidgetError: () => {
        // Intentionally empty
    },
});

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
    const [error, setError] = useState<ExpressWidgetError | null>(null);

    return (
        <ErrorContext.Provider value={{ expressWidgetError: error, setExpressWidgetError: setError }}>
            {children}
        </ErrorContext.Provider>
    );
};
